import { Box, Flex, Text } from '@chakra-ui/react'
import { Checkbox } from '@ubirider/pick-component-library'

export default function NifComponent({ isChecked, onChange, info }) {
  return (
    <Box
      border='1px solid #D0D5DD'
      borderRadius='16px'
      rounded='8px'
      p='16px'
      bg='neutral.50'
      marginBottom='8px'
      cursor='pointer'
      onClick={onChange}
    >
      <Flex gap='36px' align='center'>
        <Checkbox checked={isChecked} onChange={onChange} css={{ marginTop: '5px' }} />
        <Flex direction='column'>
          <Text fontWeight='700' fontSize='16px' color='neutral.600'>
            {info.profileName}
          </Text>
          <Text fontWeight='400' fontSize='16px' color='neutral.600'>
            {info.nif}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
